import { LogEntityComponent } from '@/ui/components/activityLogs/factory/LogEntityComponent';
import { InspectionActivities, ChecklistActivities } from '@/entities/activity/constants';
import {
  Edited,
  EditedSubmitted,
  Started,
  Submitted,
  Overdue,
  Available,
  ApprovalDeleted,
  ApprovalReset,
  ApprovalChangesRequested,
  ApprovalApproved,
  ApprovalRejected,
} from '@/ui/components/activityLogs/types/inspection';
import {
  ChecklistLog,
} from '@/ui/components/activityLogs/types/checklist';

export class LogComponent implements LogEntityComponent {
  // eslint-disable-next-line class-methods-use-this
  getComponent(activity: InspectionActivities | ChecklistActivities) {
    switch (activity) {
      case InspectionActivities.Started:
        return Started;
      case InspectionActivities.Submitted:
        return Submitted;
      case InspectionActivities.Edited:
        return Edited;
      case InspectionActivities.EditedSubmitted:
        return EditedSubmitted;
      case InspectionActivities.Available:
        return Available;
      case InspectionActivities.Overdue:
        return Overdue;
      case InspectionActivities.ApprovalDeleted:
        return ApprovalDeleted;
      case InspectionActivities.ApprovalChangesRequested:
        return ApprovalChangesRequested;
      case InspectionActivities.ApprovalApproved:
        return ApprovalApproved;
      case InspectionActivities.ApprovalRejected:
        return ApprovalRejected;
      case InspectionActivities.ApprovalReset:
        return ApprovalReset;
      case ChecklistActivities.TemplateCreated:
      case ChecklistActivities.TemplateUpdated:
      case ChecklistActivities.TemplateCreatedActive:
      case ChecklistActivities.TemplateCreatedInactive:
      case ChecklistActivities.TemplateUpdatedActive:
      case ChecklistActivities.TemplateUpdatedInactive:
        return ChecklistLog;
      default:
        throw new Error(`Log factory for activity '${activity}' not implemented`);
    }
  }
}
